/**
 * Leave Type-related GraphQL queries
 */

export const GET_LEAVE_TYPES_QUERY = `
  query GetLeaveTypes($where: leave_types_bool_exp) {
    leave_types(where: $where, order_by: { created_at: desc }) {
      id
      leave_type_name
      leave_type_description
      leave_type_status
      leave_type_days
      leave_type_hours
      leave_type_deduct_from_annual_leave
      company_id
      created_at
      company {
        id
        name
      }
    }
  }
`;

export const GET_LEAVE_TYPE_BY_ID_QUERY = `
  query GetLeaveTypeById($id: Int!) {
    leave_types_by_pk(id: $id) {
      id
      leave_type_name
      leave_type_description
      leave_type_status
      leave_type_days
      leave_type_hours
      leave_type_deduct_from_annual_leave
      company_id
      created_at
    }
  }
`;
